import { Placeholder } from '@tiptap/extensions'

export type { PlaceholderOptions } from '@tiptap/extensions'
export { Placeholder } from '@tiptap/extensions'

export default Placeholder
